// This file is derived from the Cesium math library under Apache 2 license
// See LICENSE.md and https://github.com/AnalyticalGraphicsInc/cesium/blob/master/LICENSE.md

export {INTERSECTION} from './constants';

export {default as AxisAlignedBoundingBox} from './lib/axis-aligned-bounding-box';
export {default as BoundingSphere} from './lib/bounding-sphere';
export {default as OrientedBoundingBox} from './lib/oriented-bounding-box';
export {default as CullingVolume} from './lib/culling-volume';
export {default as Plane} from './lib/plane';

export {default as _PerspectiveOffCenterFrustum} from './lib/perspective-off-center-frustum';
export {default as _PerspectiveFrustum} from './lib/perspective-frustum';

export {default as makeBoundingSphereFromPoints} from './algorithms/bounding-sphere-from-points';
export {
  makeAxisAlignedBoundingBoxFromPoints,
  makeOrientedBoundingBoxFromPoints
} from './algorithms/bounding-box-from-points';
export {default as computeEigenDecomposition} from './algorithms/compute-eigen-decomposition';

// Deprecated
export {INTERSECTION as Intersect} from './constants';
export {INTERSECTION as INTERSECT} from './constants';
